/*
 * I pannelli della sezione Tab: tab da desktop, fisarmonica da mobile.
 *
 * Il markup e' uno solo (sections/tabs-content.liquid): ogni pannello e' un
 * <details> col titolo del tab nel <summary>, e nasce aperto, cosi' da
 * desktop e' gia' giusto al primo disegno e senza JavaScript si vede tutto.
 *
 * Qui si chiudono sotto i 768px, dove il <summary> torna visibile e fa da
 * riga della fisarmonica, e si riaprono tornando a desktop. Serve toccare
 * davvero l'attributo open: il contenuto di un <details> chiuso i browser
 * recenti lo nascondono con content-visibility sullo pseudo-elemento
 * ::details-content, che il CSS del tema non puo' riaprire.
 *
 * Si passa dalla proprieta' open e non da removeAttribute perche' i <details>
 * del tema sono elementi personalizzati (accordion-group) che tengono il
 * proprio stato: scavalcandoli servirebbero due click per riaprirli.
 */
(() => {
  'use strict';

  if (window.TabsAccordion) return;

  const PANEL = '.section-tabs-content .tabs__accordion';
  const desktop = window.matchMedia('(min-width: 768px)');

  const sync = () => {
    document.querySelectorAll(PANEL).forEach((panel) => {
      if (panel.open !== desktop.matches) panel.open = desktop.matches;
    });
  };

  window.TabsAccordion = { sync };

  const start = () => {
    sync();
    desktop.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
